import { safeTrack } from "./track";
import { PAGE_KEYS } from "./pageKeys";

export function trackSpinPageView({ activityId, pagePath, pageKey = PAGE_KEYS.SPIN_MAIN }) {
  return safeTrack("spin_page_view", {
    page: pagePath || "",
    properties: {
      page_key: pageKey,
      activity_id: String(activityId || ""),
    },
  });
}

export function trackSpinDrawClick({ activityId, remainTimes, pagePath, pageKey = PAGE_KEYS.SPIN_MAIN }) {
  return safeTrack("spin_draw_click", {
    page: pagePath || "",
    properties: {
      page_key: pageKey,
      activity_id: String(activityId || ""),
      remain_times: Number(remainTimes || 0),
    },
  });
}
